import React from "react";

import "./DisplayTherapist.css";
import { saveAs } from "file-saver";

const DisplayTherapist = ({ therapist }) => {
  console.log("Forms_Location", process.env.REACT_APP_FORMS_LOCATION);
  console.log("Public URL=", process.env.REACT_APP_PUBLIC_URL);

  const handleClick = async (parameter) => {
    console.log("Downloading form from URL:", parameter);
    console.log("Full URL:", window.location.origin + parameter);

    try {
      // Fetch the PDF
      const response = await fetch(parameter);
      const blob = await response.blob();
      console.log("Blob fetched:", blob);
      console.log("Blob length:", blob.size);
      // Use file-saver to download the blob
      let bits = parameter.split("/");
      let filename = bits[bits.length - 1];
      saveAs(blob, filename);
    } catch (error) {
      console.error("Download failed:", error);
    }
  };

  return (
    <div className="displaytherapistcontainer">
      <div className="displaytherapistavatar">
        <img
          className="displaytherapistavatar"
          src={therapist.Avatar}
          alt="Avatar"
        />
      </div>
      <div className="displaytherapistname">
        {therapist.FirstName} {therapist.LastName}
      </div>
      <div className="displaytherapisttitle">{therapist.Title}</div>
      <div className="displaytherapistcontactbody">
        <div className="displaytherapistphone">
          <div className="displaytherapistphonetitle">Phone</div>
          <div className="displaytherapistphonevalue">{therapist.Phone}</div>
        </div>
        <div className="displaytherapistemail">
          <div className="displaytherapistemailtitle">Email</div>
          <div className="displaytherapistemailvalue">{therapist.Email}</div>
        </div>
      </div>
      <div className="displaytherapistbio">{therapist.Bio}</div>
      <div className="displaytherapistbody">
        <div className="displaytherapistspecialties">
          <div className="displaytherapistspecialtiestitle">Specialties</div>
          <ul>
            {therapist.Specialties !== undefined &&
              therapist.Specialties.map((specialty) => (
                <li className="displaytherapistspecialtiesitem">
                  {specialty.Description}
                </li>
              ))}
          </ul>
        </div>

        <div className="displaytherapistinsurances">
          <div className="displaytherapistinsurancestitle">
            Insurance Accepted
          </div>
          {therapist.Insurances !== undefined &&
          therapist.Insurances.length === 0 ? (
            <ul>
              <li className="displaytherapistinsuranceitem">Private Pay</li>
            </ul>
          ) : (
            <ul>
              {therapist.Insurances.map((insurance) => (
                <li className="displaytherapistinsuranceitem">
                  {insurance.Description}
                </li>
              ))}{" "}
            </ul>
          )}
        </div>
        {therapist.Forms !== undefined && therapist.Forms.length !== 0 && (
          <div className="displaytherapistforms">
            <div className="displaytherapistformstitle">Forms</div>
            <ul>
              {therapist.Forms.map((form) => (
                <li className="displaytherapistformsitem">
                  <button onClick={handleClick.bind(this, form.URL)}>
                    {form.Description}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        )}
        {therapist.TelementalHealthProviders !== undefined &&
          therapist.TelementalHealthProviders.length !== 0 && (
            <div className="displaytherapistTHP">
              <div className="displaytherapistTHPtitle">
                Telemental Health Platforms
              </div>
              <ul>
                {therapist.TelementalHealthProviders.map((thp) => (
                  <li className="displaytherapistTHPitem">
                    <a
                      className="displaytherapistTHPitem"
                      href={thp.URL}
                      target="_new"
                    >
                      {thp.Description}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          )}
      </div>
    </div>
  );
};

export default DisplayTherapist;
